import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useDashboardSearchCondition } from '@/providers/DashboardSearchConditionProvider';
import { MotionDiv } from '@/components/element/MotionDiv';
import { usePurchaseDashboardAmountByBusinessPartner } from '@/hooks/api/2190_purchase_dashboard_amount_by_business_partner';

export const AmountByBusinessPartner = () => {
  const { _w_ } = useCurrentWorkspace();
  const { purchaseOrdersDashboardSearchCondition: searchCondition, setPurchaseOrdersDashboardSearchCondition: setSearchCondition } =
    useDashboardSearchCondition();
  const { data } = usePurchaseDashboardAmountByBusinessPartner({ ...searchCondition, identifier: _w_!.identifier });

  if (!data || data.business_partner_rankings.length == 0) return <></>;

  return (
    <MotionDiv className="col-lg-6 col-xl-4">
      <div className="card mb-4 mb-lg-3">
        <div className="card-header pb-0 p-3">
          <h6 className="mb-0">取引先別</h6>
        </div>
        <div className="card-body">
          {data.business_partner_rankings.map((d, i) => (
            <div key={`a-b-bp-${i}`} className="progress-wrapper">
              <div className="d-flex align-items-center mb-2">
                <h6 className="text-xs mb-0">{d.name}</h6>
                <div className="flex-1 text-end text-xs text-mute">
                  ¥{d.contracted_amount.toLocaleString()} / ¥{d.total_amount.toLocaleString()}
                </div>
              </div>
              <div className="progress">
                <div className="progress-bar-main" style={{ width: `${Math.trunc((d.total_amount / data.total_amount) * 100)}%` }}></div>
                <div className="progress-bar-sub" style={{ width: `${Math.trunc((d.contracted_amount / data.total_amount) * 100)}%` }}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MotionDiv>
  );
};
